import AirDatepicker from 'air-datepicker';
import {add} from 'date-fns';

export default class InitDatepicker {
    constructor() {
        new AirDatepicker('.js-datepicker', {
            onSelect: function ({date, formattedDate, datepicker}) {
                datepicker.hide();
            }
        });


        document.querySelectorAll('.js-datepicker-DATE-18').forEach(el => {

            let datepickerOptions = null;

            try {
                datepickerOptions = JSON.parse(el.getAttribute('data-options'));
            } catch (e) {
            }

            new AirDatepicker(el, {
                minDate: add(new Date(), {days: 1}),
                maxDate: add(new Date(), {months: 1}),
                onSelect: function ({date, formattedDate, datepicker}) {
                    datepicker.hide();
                },
                onRenderCell({date, cellType}) {
                    if (cellType === 'day') {

                        let weekendsList = datepickerOptions?.weekends.split(',');

                        if (weekendsList) {
                            let hasBlock = weekendsList.find(week => {
                                let weekSplited = week.trim().split('.');

                                if (weekSplited[0] === (('0' + date.getDate()).slice(-2))
                                    && weekSplited[1] === (('0' + (date.getMonth() + 1)).slice(-2))
                                ) {
                                    return true
                                } else {
                                    return false;
                                }
                            });

                            if (hasBlock) {
                                return {
                                    disabled: true,
                                    classes: 'disabled-class',
                                    attrs: {
                                        title: 'Cell is disabled'
                                    }
                                }
                            }
                        }

                        // if (weekendsList) {
                        //     let hasBlock = weekendsList.map(week => {
                        //         let weekSplited = week.trim().split('.');
                        //
                        //
                        //         // console.log(('0' + date.getDate()).slice(-2));
                        //         // console.log(('0' + (date.getMonth() + 1)).slice(-2));
                        //
                        //
                        //         // if (weekSplited[0] === ('0' + date.getDate()).slice(-2) && weekSplited[1] === ('0' + (date.getMonth() + 1)).slice(-2)) {
                        //         if (weekSplited[0] === (('0' + date.getDate()).slice(-2))) {
                        //
                        //             console.log('asdasdsad', weekSplited[0], (('0' + date.getDate()).slice(-2)));
                        //
                        //             return {
                        //                 disabled: true,
                        //                 classes: 'disabled-class',
                        //                 attrs: {
                        //                     title: 'Cell is disabled'
                        //                 }
                        //             }
                        //         }
                        //     });
                        //
                        //
                        //     console.log(hasBlock);
                        // }

                        if (date.getDay() === 6 || date.getDay() === 0) {
                            return {
                                disabled: true,
                                classes: 'disabled-class',
                                attrs: {
                                    title: 'Cell is disabled'
                                }
                            }
                        }
                    }
                }
            });

        });
    }
}


window.airDatepicker = AirDatepicker;